import { Container } from '@elotech/components';
import React from 'react';

import { TelasCadastroUnicoEnum } from '../../type/enum';
import { IFrame } from '../iframe';

type Props = {
  telaUnico: TelasCadastroUnicoEnum;
  params?: Record<string, string>;
};

const UnicoCadastrosComponent: React.FC<Props> = ({ telaUnico, params }) => {
  const search = new URLSearchParams({ iframe: 'true', ...params });

  return (
    <Container breadcrumb>
      <IFrame path={`${telaUnico}?${search}`} />
    </Container>
  );
};

export { UnicoCadastrosComponent };
